(() => {
  const BUTTON_SELECTOR = '[id^="Deferred-Poster-Modal-"]';
  const OBSERVE_TIMEOUT = 2500;

  function findVideoForButton(btn) {
    const nextVideo = btn.nextElementSibling?.querySelector?.('video');
    if (nextVideo) return nextVideo;

    const parentVideo = btn.parentElement?.querySelector?.('video');
    if (parentVideo) return parentVideo;

    const idMatch = btn.id && btn.id.match(/Deferred-Poster-Modal-(.+)$/);
    if (idMatch) {
      const suffix = idMatch[1];
      const byId = document.querySelector(`video[id*="${suffix}"]`);
      if (byId) return byId;

      const byData = document.querySelector(`video[data-media-id*="${suffix}"], video[data-video-id*="${suffix}"]`);
      if (byData) return byData;
    }

    const section = btn.closest('section, .shopify-section, .video-section, .deferred-media__wrapper');
    if (section) {
      const vid = section.querySelector('video');
      if (vid) return vid;
    }
    return null;
  }

  function unmuteAndPlay(video, posterButton) {
    try {
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      try { video.muted = false; video.removeAttribute('muted'); } catch (_) {}
      try { video.currentTime = 0; } catch (_) {}

      // Enable controls when video starts playing
      video.addEventListener('play', () => {
        video.controls = true;
      }, { once: true });

      const p = video.play();
      if (p !== undefined) {
        p.then(() => console.log('[video] playing with sound'))
         .catch(err => console.warn('[video] play() rejected:', err));
      }

      // Hide the poster overlay when playing
      if (posterButton) posterButton.style.display = 'none';
    } catch (err) {
      console.error('[video] unmuteAndPlay error:', err);
    }
  }

  function setupVideoListeners(video, posterButton) {
    const labelEl = posterButton.querySelector('.click-sound-label');

    // When paused, update label text
    video.addEventListener('pause', () => {
      if (labelEl) labelEl.textContent = 'Click to play';
      if (posterButton) {
        posterButton.style.display = 'flex';
        posterButton.style.alignItems = 'center';
        posterButton.style.justifyContent = 'center';
      }
    });

    // When playing again, hide the overlay
    video.addEventListener('play', () => {
      if (posterButton) posterButton.style.display = 'none';
    });
  }

  function attemptPlayWithObserver(btn) {
    let video = findVideoForButton(btn);
    if (video) {
      setupVideoListeners(video, btn);
      unmuteAndPlay(video, btn);
      return;
    }

    const root = btn.parentElement || document;
    const obs = new MutationObserver((_mutations, observer) => {
      const v = findVideoForButton(btn);
      if (v) {
        observer.disconnect();
        setupVideoListeners(v, btn);
        unmuteAndPlay(v, btn);
      }
    });

    obs.observe(root, { childList: true, subtree: true });

    setTimeout(() => {
      try { obs.disconnect(); } catch (_) {}
      const lastTry = findVideoForButton(btn);
      if (lastTry) {
        setupVideoListeners(lastTry, btn);
        unmuteAndPlay(lastTry, btn);
      } else {
        console.warn('[video] No video element found after observing DOM for', OBSERVE_TIMEOUT, 'ms');
      }
    }, OBSERVE_TIMEOUT);
  }

  document.querySelectorAll(BUTTON_SELECTOR).forEach((posterButton) => {
    posterButton.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      attemptPlayWithObserver(posterButton);
    });
  });

  if (!document.querySelector(BUTTON_SELECTOR)) {
    console.warn('[video] No poster buttons found with selector', BUTTON_SELECTOR);
  }
})();
